import surveyAPI from 'api/base';

import { PostLinkedInAuth } from './types';

export const postLinkedInAuth: PostLinkedInAuth = (data) => {
  return surveyAPI.post('/surveys:li_verification/', data);
};
